import { OOPriceLevel } from "./oo-price-level";

export class OOMenuConfig {
	venueKey: number;
	employeeRecNum: number;
	creditPayment: string;
	giftPayment: string;
	commentsMenuId: number;
	exceptionMenuId: number;
	menus: number[];
	priceLevels: OOPriceLevel[];
	dspIncludeCustomerNameOnItem: boolean;

	public constructor(init?: Partial<OOMenuConfig>) {
		Object.assign(this, init);
	}
}
